/**
 * Generates a unique device identifier using browser information
 * This is more reliable than using hardware info as it's consistent across sessions
 */
export function generateDeviceId(): string {
  const components = [
    navigator.userAgent,
    navigator.language,
    navigator.hardwareConcurrency,
    screen.colorDepth,
  ]

  // Use SubtleCrypto to create a hash of the components
  const text = components.join('|')
  const encoder = new TextEncoder()
  const data = encoder.encode(text)

  return Array.from(data)
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')
}
